import React from 'react'
import './styles.css'
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action/index";
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn, Form} from 'semantic-ui-react'
import {Spin, Tooltip, Icon} from "antd";
import * as Validator from "../../../../util/Validator";
import $ from "jquery";
import * as common from "../../../../const/Common/CommonFunc";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import swal from "sweetalert";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import '../../../../commonBtnStyle.css'
import Update from "./Update/Update";
import apiConfig from "../../../../axios/axios_api_services";

class App extends React.Component {

  state = {
    departmentData: {
      name:
        {
          value: '',
          valid: false
        },
      valid: false
    },
    departmentData_list: [],
    formValid: false,
    isSpin: false,
    isUpdate: false,
    department_data:null
  };

  handleUpdate = () => {
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  handleChange = (name, length) => event => {
    let value = event.target.value;
    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.departmentData
    };
    formData[name].value = value;
    formData[name].valid = valid;
    formData.valid = valid;

    this.setState({
      departmentData: formData
    });
  };

  clearFeilds = () => {
    const formData = {
      ...this.state.departmentData
    };

    formData.name.valid = false;
    formData.name.value = '';
    formData.valid = false;

    this.setState({
      departmentData: formData
    });
  };

  addDepartment = (event, type) => {

    if (!this.state.departmentData.valid) {
      common.notifyMessage("Please Fill all required fields")
    } else {
      swal({
        title: "Are you sure do you want to " + type + "?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
            break;
        }
      });
    }
  };

  sendToBackend = () => {
    this.props.spinnerHandler(true);
    let dep_name =this.state.departmentData.name.value.trim();
    const obj = {
      name: dep_name
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.CORPORATE_DEPARTMENT(this.props.usr_obj.corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Department details successfully saved - (" + dep_name + ")", 0);
          this.clearFeilds();
          this.getAllDepartment();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  getAllDepartment = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.CORPORATE_DEPARTMENT(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        let length = 0;
        if (response.data.success) {
          length = response.data.departmentList.length;
          this.setState({
            departmentData_list: response.data.departmentList
          });
        } else {
          this.setState({
            departmentData_list: []
          })
        }

        //  dashboard single type
        this.props.addTagsDashboardSingle("departmentCount",length);
        //  --------
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDepartment()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  };
  deleteDep = (id, name) => {
    swal({
      title:"Do you want to delete this department? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteDep_(id)
        }else{
          common.warningAlert("Can't delete department", 1)
        }
      });
  };

  deleteDep_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_DEPARTMENT_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Department details successfully deleted", 0);
          this.clearFeilds();
          this.getAllDepartment();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteDep_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  updateDep = (obj) => {
    this.setState({
      department_data:obj,
      isUpdate: true
    })
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllDepartment();
  }

  render() {
    const rows = [];

    if (this.state.departmentData_list.length !== 0) {
      this.state.departmentData_list.map((row, index) => {
        rows.push(
          {
            id: row.departmentId,
            name: row.name,
            action:
              <div>
                <SementicBtn circular icon='edit' onClick={e => this.updateDep(row)} className={"more-update"}/>
                <SementicBtn circular icon='trash alternate' className={"more-remove"}
                             onClick={e => this.deleteDep(row.departmentId, row.name)}/>
              </div>
          }
        )
      });
    }

    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (
      <div>
        {
          this.state.isUpdate ?
            <Update refreshData={this.getAllDepartment} closeModal={this.handleUpdate} data={this.state.department_data}/>
            : null
        }
        <Card>
          <CardHeader>Manage Department</CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Department Name"}
                          placeholder={"Department Name"}
                          value={this.state.departmentData.name.value}
                          onChange={this.handleChange('name', 1)}
                        />
                      </Form.Group>
                    </Form>
                  </Col>

                  <Col lg={6}>

                    <Row>
                      <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                        <center>

                          <Button
                            className="submit-btn"
                            color="warning"
                            // disabled={!this.state.departmentData.valid}
                            onClick={e => this.addDepartment(e, 'Create Department')}
                          >Create Department</Button>

                          {/*<Tooltip placement="topLeft" title="Clear input fields">*/}
                            {/*<SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>*/}
                          {/*</Tooltip>*/}

                        </center>

                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>


        <Card>
          <CardHeader>All Department</CardHeader>
          <CardBody>
            <Spin spinning={this.state.isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>

              <MDBDataTable
                searching={true}
                displayEntries={true}
                entries={8}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>

          </CardBody>
        </Card>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  table_data: state.COPAdminReducer.departmentTable_data,
  // departmentData: state.COPAdminReducer.departmentData, <-- not use
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addDepartment: (data) => dispatch(actionCreator.addDepartment(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard single value handler
    addTagsDashboardSingle: (type,data) => dispatch(actionCreator.addTagsDashboardSingle(type,data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
